import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';
import { NominationScrubbingStatus } from '../../models';

export const updateAwardNominationScrubbingStatus: (
  fetchContext: FetchContext,
  awardId: number, 
  nominationId: number, 
  scrubbingStatus: NominationScrubbingStatus,
  accessToken?: string,
) => Promise<void> = (fetchContext, awardId, nominationId, scrubbingStatus, accessToken) => fetch(`${fetchContext.baseUrl}/api/staff/awards/${awardId}/nominations/${nominationId}/scrubbing-status`,
  {
    method: 'PUT',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(scrubbingStatus),
  })
  .then((response) => responseErrorHandler<void>(fetchContext.errorStore, response, 'update award nomination scrubbing status'));
